import Api from './Api'

export default {
  getSkyObjects(type) {
    // Use GET for all sky objects (location, evse, price-plan, subscription-plan)
    // This uses the admin endpoint with Authorization token
    return Api().get(`/sky/${type}`)
  },
  getSkyObject(type, id) {
    return Api().get(`/sky/${type}/${id}`)
  },
  saveSkyObject(type, data) {
    return Api().put(`/sky/${type}`, data)
  }
  // saveUser(data) {
  //   return Api().put('/user', data)
  // }
}